module.exports = __webpack_public_path__ + "static/img/4638_phase_function_Paper_PointsHejduk_Prediction.0895410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4638_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5PjA
// module chunks = 0